// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tree-detail--tree-info {\n  text-align: left;\n}\n\n.tree-detail--tree-name-info > .container,\n.tree-detail--tree-detail-gallery > .container {\n  padding: 1rem 1.7rem !important;\n}\n\n.tree-detail--nursury-warning {\n  border: 3px solid #457537;\n  border-radius: 4px;\n}\n\n@media (min-width: 576px) {\n  .tree-detail--nursury-warning {\n    display: flex;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
